module.exports.numberWithCommas = function (x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

module.exports.map = function (v, in_min, in_max, out_min, out_max) {
  return ((v - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
}
